(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class DNAAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.rafHandle = null;
    }
    connectedCallback() {
      this.$announcementBarSlider = this.querySelector('.announcement-bar__carousel');
      this.$announcementBarSlides = this.$announcementBarSlider?.querySelectorAll('.announcement-bar__carousel-item:not([data-clone])');
      this.$announcementBarSlider.addEventListener('sl-slide-change', this._handleSlideChange);
      this.$announcementBarNextArrow = this.querySelector('.js-arrow-next');
      this.$announcementBarPrevArrow = this.querySelector('.js-arrow-prev');

      window.addEventListener('resize', this._handleResize);
      // If a non-first slide ends up taking up 2 text lines,
      // the carousel doesn't expand until it's initialized,
      // so we need to re-determine the header height after that happens
      Promise.all([
        window.customElements.whenDefined('sl-carousel'),
        window.customElements.whenDefined('sl-carousel-item')
      ]).then(this._handleResize);

      document.addEventListener('DOMContentLoaded', () => {
        this.$announcementBarSlider?.goToSlide?.(0);
      });

      if (this.$announcementBarSlides?.length) {
        for (const $slide of this.$announcementBarSlides) {
          $slide.addEventListener('click', (event) => this._trackSlideClick(event.target));
        }
        if (this.$announcementBarSlides.length > 1) {
          this.$announcementBarNextArrow.addEventListener('click', () => {
            this.$announcementBarSlider.next();
            this._trackSlideScroll('next');
          });
          this.$announcementBarPrevArrow.addEventListener('click', () => {
            this.$announcementBarSlider.previous();
            this._trackSlideScroll('previous');
          });
        }
      }
    }
    disconnectedCallback() {
      this.$announcementBarSlider.removeEventListener('sl-slide-change', this._handleSlideChange);
      window.removeEventListener('resize', this._handleResize);
      if (this.$announcementBarSlides?.length) {
        for (const $slide of this.$announcementBarSlides) {
          $slide.removeEventListener('click', (event) => this._trackSlideClick(event.target));
        }
        if (this.$announcementBarSlides.length > 1) {
          this.$announcementBarNextArrow.removeEventListener('click', () => {
            this.$announcementBarSlider.next();
            this._trackSlideScroll('next');
          });
          this.$announcementBarPrevArrow.removeEventListener('click', () => {
            this.$announcementBarSlider.previous();
            this._trackSlideScroll('previous');
          });
        }
      }
    }
    _handleResize = () => {
      // Since our header is position fixed and not position sticky,
      // the main section needs to be dropped by the rendered height of
      // the hello bar plus the nav minus the one pixel border
      // if we ever refactor the nav to be sticky instead, this could go away
      if (!this.rafHandle) {
        this.rafHandle = window.requestAnimationFrame(() => {
          document
            .querySelector(':root')
            .style.setProperty(
              '--dna-header-height',
              `${document.querySelector('dna-header').getBoundingClientRect().height - 1}px`
            );
          this.rafHandle = undefined;
        });
      }
    }
    // Unfortunetly due to the navigation arrows, we need to do this...
    _handleSlideChange = ({ detail: { slide } }) => {
      this.style.color = slide.style.color;
      this.style.background = slide.style.background;
    }
    _trackSlideClick(el) {
      const $slideLink = el.closest('a');
      const $slideText = $slideLink.querySelector('.p2:first-of-type');
      const Segment = __DNA_GLOBAL__?.vendor?.Segment;
      // @segment
      Segment.protect(() => {
        Segment.track(Segment.CONSTANTS.EVENTS.NOTIFICATION_BAR_CLICKED, {
          notification_bar_cta_text: $slideText?.textContent.trim(),
          notification_bar_cta_link: $slideLink?.getAttribute('href'),
        });
      });
    }
    _trackSlideScroll(direction) {
      const $activeSlide = this.$announcementBarSlider.querySelector('sl-carousel-item.--in-view');
      const $activeSlideText = $activeSlide.querySelector('.p2:first-of-type');
      const $activeSlideLink = $activeSlide.querySelector('a');
      const Segment = __DNA_GLOBAL__?.vendor?.Segment;
      // @segment
      Segment.protect(() => {
        Segment.track(Segment.CONSTANTS.EVENTS.NOTIFICATION_BAR_SCROLLED, {
          notification_bar_cta_text: $activeSlideText?.textContent.trim(),
          notification_bar_cta_link: $activeSlideLink?.getAttribute('href') || undefined,
          notification_bar_scroll_direction: direction,
        });
      });
    }
  }
  customElements.define('dna-announcement-bar', DNAAnnouncementBar);

  class DNACountDown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.initializeCountDown();
    }
    initializeCountDown() {
      const countdownEnd = this.getAttribute('data-end');
      const pstDiff = this.getAttribute('data-pst');
      if (!!countdownEnd) {
        const countDownDate = new Date(countdownEnd.replace(' ', 'T') + `.000${pstDiff}:00`).getTime();
        const timer = setInterval(() => {
          // Get today's date and time in PST
          const currentDate = new Date();
          // Find the distance between now and the count down date
          const distance = countDownDate - currentDate;
          // Time calculations for days, hours, minutes and seconds
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
          let countdownStr =
            (hours > 9 ? hours : `0${hours}`) +
            ':' +
            (minutes > 9 ? minutes : `0${minutes}`) +
            ':' +
            (seconds > 9 ? seconds : `0${seconds}`);
          if (days > 0) {
            countdownStr = days + ':' + countdownStr;
          }
          // If the count down is finished, remove the text
          if (distance < 0) {
            clearInterval(timer);
            countdownStr = '';
          }
          this.innerText = countdownStr;
        }, 1000);
      }
    }
  }
  customElements.define('dna-count-down', DNACountDown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  /**
   * Redirect to the homepage if there is no query parameter
   */
  (function () {
    const urlParams = new URLSearchParams(window.location.search);
    const hasQuery = urlParams.has('q');
    if (!hasQuery) {
      window.location.href = Shopify.routes.root;
    }
  })();

  document.addEventListener('DOMContentLoaded', () => {
    const Segment = __DNA_GLOBAL__.vendor.Segment;
    const searchResults = document.querySelector('.js-search-results');
    const searchResultsCount = document.querySelector('.js-search-results-count');

    const constructorResults = document.querySelector('dna-constructor-results');

    constructorResults.addEventListener('dna:load:start', () => {
      searchResults.classList.remove('search-complete');
    });

    constructorResults.addEventListener('dna:constructor-results:loaded', (event) => {
      const resultsCount = event?.detail?.pagination?.totalResults || 0;

      searchResults.classList.add('search-complete');
      searchResultsCount.textContent = resultsCount;

      // This class is used to show/hide flexible blocks when there are no results
      // See flexible.liquid
      if (resultsCount === 0) {
        document.body.classList.add('no-results');
      }

      // @segment
      Segment.protect(() => {
        Segment.track(Segment.CONSTANTS.EVENTS.PRODUCTS_SEARCHED, {
          query: document.querySelector('.js-search-results-term')?.textContent?.trim(),
          query_source: 'search page',
          results: resultsCount,
        })
      })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super()

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return
        observer.unobserve(this)

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div')
            html.innerHTML = text
            const recommendations = html.querySelector('product-recommendations')
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML
            }
          })
          .catch((e) => {
            console.error(e)
          })
      }

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this)
    }
  }

  customElements.define('product-recommendations', ProductRecommendations)

  } catch(e) { console.error(e); }
})();
})();
